import React, { createContext, useState, useEffect } from "react";
import Cookies from 'js-cookie';
import MainLoading from '../components/mains/MainLoading'
const context = createContext(null);

const UserProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const [stock, setStock] = useState(false);
  const [stockInfo, setStockInfo] = useState({});
  const [success, setSuccess] = useState(false);
  const [password, setPassword] = useState(false);
  const [banned, setBanned] = useState(false);

  useEffect(() => {
      setLoading(true)
      var user_data_cookie = Cookies.get('user_data')
      if (user_data_cookie){
        var user_data = JSON.parse(Buffer.from(user_data_cookie, 'base64').toString())
        setUser(user_data)
        setSuccess(localStorage.getItem('purchased_infinit') === 'true')
        if(!success){
            const urlquery = window.location.search;
            const urlParams = new URLSearchParams(urlquery);
            const password = urlParams.get('password')

            fetch(`${process.env.REACT_APP_API_URL}/stock/?password=`+password, {
            headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
            credentials: 'include',
            method: 'GET',
            })
            .then(function (res) {
              if(res.status === 200){
                res.json().then(function(data){
                  if(data.available === true) {
                    setStock(true)
                    setStockInfo(data.price)
                  }
                  else {
                    setStock(false)
                  }
                  if(data.message === "Invalid password"){
                    setPassword(false)
                  }
                  else{
                    setPassword(true)
                  }
                  setLoading(false)
                })
              }
              else if(res.status === 403){
                res.json().then(function(data){
                  if(data.message === "Banned"){
                    setBanned(true)
                  }
                })
                setStock(false)
                setLoading(false)
              }
              else{
                setStock(false)
                console.log('Internal Server Error');
                setLoading(false)
              }
            })     
            .catch(err => {
                setStock(false)
                console.log(err);
                setLoading(false)
            });   
        }     
      } else {
        setLoading(false) 
      }
  }, []);

  return (
    <div className="parent">
      {
        !loading &&
        <context.Provider value={{user, loading, stock, success, password, banned, stockInfo}}>
            {children}
        </context.Provider>
      }
      {
        loading &&
        <div className="parent">
          <MainLoading/>
        </div>
      }
    </div>
  );
};

UserProvider.context = context;

export default UserProvider;
